import React from 'react';

import './StyledRoot.module.css';

const StyledRoot = ({ children }) => <div styleName="root">{children}</div>;

export default StyledRoot;
